import React from 'react';

export default function ArrowsMergeIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-arrows-merge"><g><path className="secondary" d="M10 6h4v1.86a8 8 0 0 0 2.34 5.65l5.37 5.37a1 1 0 0 1 0 1.41l-1.42 1.42a1 1 0 0 1-1.41 0l-5.37-5.37A12 12 0 0 1 10 7.86V6z"/><path className="primary" d="M13.95 9a12 12 0 0 1-3.46 7.34l-5.37 5.37a1 1 0 0 1-1.41 0l-1.42-1.42a1 1 0 0 1 0-1.41l5.37-5.37A8 8 0 0 0 9.92 9H7a1 1 0 0 1-.7-1.7l5-5a1 1 0 0 1 1.4 0l5 5A1 1 0 0 1 17 9h-3.05z"/></g></svg>
    </Tag>
  )
};
